"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTION_PING_INTERVAL_MS = exports.CONNECTION_ESTABLISHED_MS = exports.SHORT_CONVO_LENGTH_MS = exports.MAP_NAME_TO_CATEGORY = exports.MapCategory = void 0;
var MapCategory;
(function (MapCategory) {
    MapCategory["CONFERENCE"] = "conference";
    MapCategory["CUSTOM"] = "custom";
    MapCategory["DOMESTIC"] = "domestic";
    MapCategory["EDUCATION"] = "education";
    MapCategory["MOONPOND"] = "moonpond";
    MapCategory["OFFICE"] = "office";
    MapCategory["OTHER"] = "other";
    MapCategory["PUBLIC"] = "public";
    MapCategory["RECESS"] = "recess";
    MapCategory["SOCIAL"] = "social";
    MapCategory["WALKTHROUGH"] = "walkthrough";
})(MapCategory || (exports.MapCategory = MapCategory = {}));
exports.MAP_NAME_TO_CATEGORY = {
    "beach-conference": MapCategory.CONFERENCE,
    "conference-basic-foyer": MapCategory.CONFERENCE,
    "conference-basic-main": MapCategory.CONFERENCE,
    "conference-deluxe-main": MapCategory.CONFERENCE,
    demo_conference_foyer: MapCategory.CONFERENCE,
    demo_conference_main: MapCategory.CONFERENCE,
    keynote: MapCategory.CONFERENCE,
    "poster-room-big": MapCategory.CONFERENCE,
    "poster-room-small": MapCategory.CONFERENCE,
    "custom-entrance": MapCategory.CUSTOM,
    "empty-100x100": MapCategory.CUSTOM,
    "empty-22x22": MapCategory.CUSTOM,
    "empty-45x45": MapCategory.CUSTOM,
    apartment: MapCategory.DOMESTIC,
    "family-gathering": MapCategory.DOMESTIC,
    "family-gathering-lny": MapCategory.DOMESTIC,
    "family-gathering-cozy": MapCategory.DOMESTIC,
    study: MapCategory.DOMESTIC,
    "auditorium-lecture-hall": MapCategory.EDUCATION,
    "classroom-large": MapCategory.EDUCATION,
    "classroom-small": MapCategory.EDUCATION,
    NAIST_Campus: MapCategory.EDUCATION,
    "school-medium-hs-common-room": MapCategory.EDUCATION,
    "school-small-hs-common-room": MapCategory.EDUCATION,
    "uni-department-common": MapCategory.EDUCATION,
    "uni-lab": MapCategory.EDUCATION,
    "uni-quad": MapCategory.EDUCATION,
    moonpond: MapCategory.MOONPOND,
    "new office": MapCategory.OFFICE,
    "office-large-light-main": MapCategory.OFFICE,
    "office-large-wood-main": MapCategory.OFFICE,
    officeMedium: MapCategory.OFFICE,
    "office-medium-dark": MapCategory.OFFICE,
    "office-medium-light": MapCategory.OFFICE,
    "office-medium-wood": MapCategory.OFFICE,
    "office-new": MapCategory.OFFICE,
    "office-small-dark": MapCategory.OFFICE,
    "office-small-light": MapCategory.OFFICE,
    "office-small-wood": MapCategory.OFFICE,
    "office-tiny-dark": MapCategory.OFFICE,
    "office-tiny-light": MapCategory.OFFICE,
    "office-tiny-wood": MapCategory.OFFICE,
    "demo-uni": MapCategory.PUBLIC,
    "live-demo_conference_foyer": MapCategory.PUBLIC,
    "public-zoom-uni-quad": MapCategory.PUBLIC,
    recess: MapCategory.RECESS,
    castle: MapCategory.SOCIAL,
    "beer-garden": MapCategory.SOCIAL,
    loungeLarge: MapCategory.SOCIAL,
    loungeSmall: MapCategory.SOCIAL,
    "lounge-large": MapCategory.SOCIAL,
    "lounge-small": MapCategory.SOCIAL,
    park: MapCategory.SOCIAL,
    rooftop: MapCategory.SOCIAL,
    waterfront: MapCategory.SOCIAL,
    "room 1 - entrance": MapCategory.WALKTHROUGH,
};
exports.SHORT_CONVO_LENGTH_MS = 5000;
exports.CONNECTION_ESTABLISHED_MS = 5000;
exports.CONNECTION_PING_INTERVAL_MS = 1000 * 60 * 2;
//# sourceMappingURL=constants.js.map